import { pb } from './pocketbase';

/**
 * Récupérer tous les articles
 */
export const getArticles = async () => {
  try {
    const records = await pb.collection('articles').getFullList({
      sort: '-created',
      expand: 'category'
    });
    return records;
  } catch (error) {
    console.error('Erreur lors de la récupération des articles:', error);
    throw error;
  }
};

/**
 * Récupérer les articles pour le carrousel (carrousel = true)
 */
export const getCarrouselArticles = async () => {
  try {
    const records = await pb.collection('articles').getFullList({
      filter: 'carrousel = true',
      sort: '-created',
      expand: 'category'
    });
    return records;
  } catch (error) {
    console.error('Erreur lors de la récupération des articles carrousel:', error);
    throw error;
  }
};

/**
 * Récupérer un article par son ID
 */
export const getArticleById = async (id) => {
  try {
    const record = await pb.collection('articles').getOne(id, {
      expand: 'category'
    });
    return record;
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'article:', error);
    throw error;
  }
};

/**
 * Récupérer un article par son slug
 */
export const getArticleBySlug = async (slug) => {
  try {
    const records = await pb.collection('articles').getFullList({
      filter: `slug = "${slug}"`,
      expand: 'category'
    });
    return records[0] || null;
  } catch (error) {
    console.error('Erreur lors de la récupération de l\'article par slug:', error);
    throw error;
  }
};
